export const CDN_BASE_URL =
  'https://s3.ca-central-1.amazonaws.com/assets.jaqln.ai';
